<template>
    <div class="ds-exchange-card-assignee">
        <User :first-name="user.first_name" :last-name="user.last_name" :avatar="user.avatar" :subtitle="user.position?.name" exchange />
        <div v-if="income && !rejected" class="ds-exchange-card-footer-actions flex items-center">
        <div class="cursor-pointer pl-3 text-green ds-exchange-card-action">
            <icon @click="assignUser">
                <IconApprove />
            </icon>
        </div>
        <div class="cursor-pointer pl-1 text-darkred ds-exchange-reject-action">
            <icon class="ds-exchange-reject-action-icon" @click="rejectUser">
                <IconClose />
            </icon>
        </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    vacancyId: string,
    user: any,
    income: boolean,
    rejected: boolean
}

import User from '../User.vue'
import IconApprove from '@/ui/icons/IconApprove.vue'
import IconClose from '@/ui/icons/IconClose.vue'
import { useExchangeStore } from '@/stores/exchangeStore'
import { useAuthStore } from '@/stores/authStore'
import { useToast } from 'vue-toast-notification'

const authStore = useAuthStore()
const exchangeStore = useExchangeStore()

const { user, vacancyId } = defineProps<Props>()
const toast = useToast({ position: 'top' })

const assignUser = async () => {
    if (authStore.permissions?.can_confirm_vacancy_request) {
        await exchangeStore.confirmVacancyAssignation(vacancyId, user.id)
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

const rejectUser = async () => {
    await exchangeStore.rejectRequest(vacancyId)
}

</script>
